import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { IFile } from '../models/i-file';
import { IFileCard } from '../models/i-person-card';
import { ApiResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private http: HttpClient) { }

  GetFile(file: string): Observable<string> {
    return this.http.get(`assets/docs/${file}.TXT`, { responseType: 'text' })
  }

  GetJson(json: string): Observable<any> {
    return this.http.get(`assets/json/${json}.json`, { responseType: 'json' })
  }
  
  UploadCardsFile(formData: FormData): Observable<ApiResponse<IFileCard[]>> {
    return this.http.post<ApiResponse<IFileCard[]>>(
      `${Constants.API_URL}api/File/UploadCardsFile`, formData);
  }

  DownloadDocumentFile(DocumentId: number): Observable<ApiResponse<IFile>>{
    return this.http.get<ApiResponse<IFile>>(
        `${Constants.API_URL}api/Template/DownloadDocumentFile?DocumentId=${DocumentId}`)
  }

  DownloadMassiveTemplateFile(): Observable<ApiResponse<IFile>>{
    return this.http.get<ApiResponse<IFile>>(
        `${Constants.API_URL}api/File/DownloadMassiveTemplateFile`)
  }
}
